<router-outlet>
  <div class="position-fixed bottom-0 end-0 p-3 toast-container" style="z-index: 5">
    <div *ngFor="let toast of toastService.toasts">
      <toast [toast]="toast"></toast>
    </div>
  </div>
</router-outlet>